<div class="logo-carousel">
  <div class="carousel-wrapper swiper" [class]="uniqueId">
    <div class="carousel-inner-wrapper swiper-wrapper">
      @for (image of images(); track image.id) {
        <div class="carousel-item swiper-slide">
          <img
            [ngSrc]="image.src"
            [width]="image.width"
            [height]="image.height"
            [alt]="image.alt"
          />
        </div>
      }
    </div>
  </div>
</div>